import L from 'leaflet';
import { getSvgIconId } from '../../Util/getSvgIconId';
import type { SvgIconOptions } from './SvgIcon.types';

export interface SvgIcon {
    _setIconStyles(icon: HTMLElement, iconString: string): void;
}

export class SvgIcon extends L.Icon<SvgIconOptions> {
    constructor(options: SvgIconOptions) {
        super(options);
    }

    createIcon(oldIcon?: HTMLElement): HTMLElement {
        const id = this.options.iconId;

        if (!id) {
            return null;
        }

        const icon = this._createSvg(id, oldIcon && oldIcon.tagName === 'DIV' ? oldIcon : null);
        if (this.options.className) {
            icon.classList.add(this.options.className);
        }

        this._setIconStyles(icon, 'icon');

        if (this.options.title) {
            icon.setAttribute('title', this.options.title);
        }

        if (this.options.color) {
            icon.style.color = this.options.color;
        }

        if (this.options.opacity) {
            icon.style.opacity = this.options.opacity.toString();
        }

        icon.style.display = 'flex';

        return icon;
    }

    createShadow(): null {
        return null;
    }

    _createSvg(iconId: number | string, el?: HTMLElement): HTMLElement {
        el = el || document.createElement('div');

        while (el.firstChild) {
            el.removeChild(el.firstChild);
        }

        const svgEl = generateSvgElement(iconId, this.options.combinationIcon);
        el.appendChild(svgEl);

        return el;
    }
}

export const generateSvgElement = (iconId: number | string, combinationIcon = false): SVGElement => {
    const svgns = 'http://www.w3.org/2000/svg';
    const xlinkns = 'http://www.w3.org/1999/xlink';
    const svgEl = document.createElementNS(svgns, 'svg');

    svgEl.setAttribute('class', 'svg-icon');
    svgEl.setAttributeNS('http://www.w3.org/2000/xmlns/', 'xmlns', svgns);
    svgEl.setAttributeNS('http://www.w3.org/2000/xmlns/', 'xmlns:xlink', xlinkns);
    const useSvg = document.createElementNS(svgns, 'use');

    const iconIdentifier = getSvgIconId(iconId);
    useSvg.setAttributeNS(xlinkns, 'href', iconIdentifier);

    if (combinationIcon) {
        const useSvg2 = document.createElementNS(svgns, 'use');
        useSvg2.setAttributeNS(xlinkns, 'href', '#symbol_104x_background');
        svgEl.appendChild(useSvg2);
    }

    svgEl.appendChild(useSvg);

    // Safari xlink NS issue fix
    svgEl.innerHTML = svgEl.innerHTML.replace(/NS\d+:href/gi, 'xlink:href');

    return svgEl;
};
